import { defineNuxtPlugin } from '@nuxtjs/composition-api';
export default defineNuxtPlugin((nuxtApp) => {
  const config = nuxtApp.$config;
  const store = nuxtApp.app.store;

  const locale = nuxtApp.app.i18n?.locale || 'en';

  const localeSites = store?.state?.global?.localeSites || {};
  const siteHandle = localeSites?.[locale]?.siteHandle || 'default';

  const normalizeSiteHandle = (s) => {
    const raw = String(s || '').trim().toLowerCase();
    if (raw === 'english') return 'default';
    return raw;
  };

  const configured = (config.enabledSearchSites || '')
    .split(',')
    .map(normalizeSiteHandle)
    .filter(Boolean);

  const defaultEnabled = Object.values(localeSites)
    .map((s) => s?.siteHandle)
    .filter(Boolean);

  const enabledSites = (configured.length ? configured : defaultEnabled.map(normalizeSiteHandle)).filter(Boolean);
  const enableSearch = enabledSites.includes(normalizeSiteHandle(siteHandle));

  store.commit('global/setEnabledSearchLocales', enabledSites);
  store.commit('global/updateSearchFunctionality', enableSearch);
});
